import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import ButtonHeader from '../components/ButtonHeader.jsx';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    float: 'left',
    rowGap: theme.spacing(1.5),
    padding: theme.spacing(2),
  },
  button: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    alignSelf: 'center',
  },
}));

const MobileCredentialPage = () => {
  const classes = useStyles();

  const appClientId = 'cbe37142-c34a-47f7-b84e-de62fb37fe2e';
  const appScope =
    'openid offline_access https://pdcmc.onmicrosoft.com/cbe37142-c34a-47f7-b84e-de62fb37fe2e/WebServiceAPI';

  const { search } = window.location;
  const params = new URLSearchParams(search);
  const result = params.get('result');

  const generateSignInLink = (responseType, redirectUri, clientId, scope) => {
    // TODO: Add and verify state?
    return `https://pdcmc.b2clogin.com/pdcmc.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_susi&nonce=defaultNonce&response_type=${responseType}&prompt=login&redirect_uri=${redirectUri}&client_id=${clientId}&scope=${scope}`;
  };

  return (
    <>
      <ButtonHeader title="Mobile Credentials" />
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link color="inherit" href="/admin">
          Administration
        </Link>
        <Link color="inherit" href="/globalSettings/globalSetting">
          Global Settings
        </Link>
        <Typography color="textPrimary">Mobile Credentials</Typography>
      </Breadcrumbs>
      <br />
      <div className={classes.root}>
        <Card className={classes.card} square>
          <Typography variant="h6">Mobile Credential Authentication</Typography>
          {result && result === 'success' && (
            <Typography color="secondary">Successfully authenticated</Typography>
          )}
          {result && result === 'failure' && (
            <Typography color="error">Failed to authenticate</Typography>
          )}
          <Typography>Sign in with Azure AD to enable mobile credentials.</Typography>
          <Button
            className={classes.button}
            variant="contained"
            href={generateSignInLink(
              'code',
              `${window.location.href.split('?')[0]}/auth`,
              appClientId,
              appScope
            )}
          >
            Sign in
          </Button>
        </Card>
      </div>
    </>
  );
};

export default MobileCredentialPage;
